const createClient = (
  baseUrl?: string,
  getToken?: () => Promise<string | undefined>
) => {
  return {
    token: getToken,
    get: async <t>(endpoint: string, body?: any, skipToken = false) => {
      const token = await getToken?.();

      const headers: Record<string, string> = {
        // 'Content-Type': 'application/json',
      };

      if (token && !skipToken) {
        headers['authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(baseUrl + endpoint, {
        method: 'GET',
        mode: 'cors',
        headers,
        body: body ? JSON.stringify(body) : undefined,
      });

      if (endpoint.includes('/tradier/auth-exchange') && response?.ok) {
        return 'ok' as t;
      }

      if (!response.ok) {
        const e = new Error(`Failed to fetch ${endpoint}`) as Error & {
          code: number;
        };
        e.code = response.status;
        e.message = response.json ? await response.json() : response.statusText;
        throw e;
      }

      return response.json() as t;
    },
    post: async <t>(endpoint: string, body: any) => {
      const token = await getToken?.();

      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw await response.json();
      }

      if (endpoint === '/tradier/orders' && body?.targetPositionId) {
        try {
          const res = await response.json();

          return res as t;
        } catch (e) {
          console.error(e);
        }
      }

      // if (endpoint === '/registrations') {
      //   return {
      //     activationCode: response.status,
      //   } as t;
      // }

      if (
        endpoint === '/positions/previews' ||
        endpoint === '/watchlists' ||
        (endpoint === '/tradier/orders' && body?.preview)
      ) {
        return 'success' as t;
      }

      try {
        const res = await response.json();

        return res as t;
      } catch (e) {
        return response.statusText as t;
      }
    },
    put: async <t>(endpoint: string, body: any) => {
      const token = await getToken?.();

      const response = await fetch(baseUrl + endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Failed to patch to ${endpoint}`);
      }

      if (
        endpoint.includes('/previews') ||
        endpoint.includes('/notifications')
      ) {
        return 'success' as t;
      }

      return response.json() as t;
    },
    patch: async <t>(endpoint: string, body: any) => {
      const token = await getToken?.();

      const response = await fetch(baseUrl + endpoint, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Failed to patch to ${endpoint}`);
      }

      if (
        endpoint.includes('/previews') ||
        endpoint.includes('/notifications')
      ) {
        return 'success' as t;
      }

      return response.json() as t;
    },
    delete: async <t>(endpoint: string, body?: any) => {
      const token = await getToken?.();

      const response = await fetch(baseUrl + endpoint, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body || {}),
      });

      if (!response.ok) {
        throw await response.json();
      }

      if (endpoint === '/registrations') {
        return {
          status: response.status,
        } as t;
      }

      if (
        endpoint === '/price-alerts' ||
        endpoint === '/position-price-alerts' ||
        endpoint === '/positions/previews' ||
        endpoint.includes('/watchlists') ||
        endpoint.includes('/tradier/orders')
      ) {
        return 'success' as t;
      }

      return response.json() as t;
    },
  };
};

export default createClient;
